import { IComponentOptions } from 'angular';
import { CourseSetupWizardViewController } from './course-setup-wizard-view.controller';
import template from './course-setup-wizard-view.component.html';

export const CourseSetupWizardViewComponent = {
	controller: CourseSetupWizardViewController,
	require: {
		wizardController: '^wizard'
	},
	template
} as IComponentOptions;
